import Monster from "../../Monster";
import IPositioner from "./IPositioner";

export class DefaultPositioner implements IPositioner {
    public Position(monster: Monster): void {
        
    }
}